import { SalaryCardActionTypes, SetXrfValueAction } from "store/types/salaryCard";

export const setXrfValue = (value:string): SetXrfValueAction => ({
     type: SalaryCardActionTypes.SET_XRF_VALUE,
     payload: value
  })